import { useContext } from "react";

import { I18nContext, type I18nContextValue } from "./provider";

/**
 * `const { t } = useTranslation()` — the only way a component reads a string.
 *
 * `locale` comes with it for the rare caller that needs to format rather than translate (an
 * `Intl` constructor, say). Never for a machine format: `lib/zoned-day.ts` deliberately pins
 * `en-CA` because its output is a Map key, not text a person reads.
 */
export function useTranslation(): I18nContextValue {
  return useContext(I18nContext);
}
